import { render, staticRenderFns } from "./contactListComponent.vue?vue&type=template&id=3f6d31b1&scoped=true&"
import script from "./contactListComponent.vue?vue&type=script&lang=js&"
export * from "./contactListComponent.vue?vue&type=script&lang=js&"
import style0 from "./contactListComponent.vue?vue&type=style&index=0&id=3f6d31b1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6d31b1",
  null
  
)

export default component.exports